import * as React from 'react';
import TopProductDetail from "./TopProductDetail/TopProductDetail";
import ProductDetailTabs from "./ProductDetailTabs/ProductDetailTabs";
import ProductDetailBuyBox from "../ProductDetailRightContent/ProductDetailBuyBox";
import {useAxiosIndicatorCheck} from "../../../store/hook/useAxiosIndicatorCheck";

const ProductDetailLeftContent = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    return (
        <>
            <div className="col-12">
                <>
                    <TopProductDetail/>
                     <div className="desktophide mobileshow mt-3">
                        <ProductDetailBuyBox fetch_stock_alert_products_details={props.fetch_stock_alert_products_details}/>
                    </div>
                    <ProductDetailTabs/>
                </>
            </div>
        </>
    );
}

export default ProductDetailLeftContent;